// import Observability from '@launchdarkly/observability'
// import SessionReplay from '@launchdarkly/session-replay'
import { LDPlugin } from 'launchdarkly-vue-client-sdk'
import { LaunchDarkly } from '$services/launchdarkly'

export default defineNuxtPlugin((nuxtApp) => {
    const runtimeConfig = useRuntimeConfig()
    const launchDarklyProvider = new LaunchDarkly.LaunchDarklyPlugin(<LaunchDarkly.InitOptions>{
        ...runtimeConfig.public.launchDarkly
    })

    const plugins: any[] = [
        // new Observability({
        //     networkRecording: {
        //         enabled: true,
        //         recordHeadersAndBody: true
        //     }
        // })
    ]

    // // Session replay causes CORS issues in local development. Don't include this plugin when running locally.
    // if (process.env.NODE_ENV !== 'development') {
    //     plugins.push(
    //         new SessionReplay({
    //             // Use 'none' to turn off session replay obfuscation. To learn more, read: https://launchdarkly.com/docs/sdk/features/session-replay-config#privacy
    //             privacySetting: 'none'
    //         })
    //     )
    // }

    nuxtApp.vueApp.use(LDPlugin, {
        clientSideID: runtimeConfig.public.launchDarkly.id,
        deferInitialization: true,
        options: {
            plugins
        }
    })

    return {
        provide: {
            launchDarkly: launchDarklyProvider
        }
    }
})
